import { createScriptLoader } from '@bigcommerce/script-loader';
const loader = createScriptLoader();

loader.loadScript('https://canny.io/sdk.js', { async: true });
